import { getSinaState } from './sinaStates.js';
import './SinaContextualCue.css';

/** Aviso contextual breve para que Sina acompañe una validación sin bloquear el flujo. */
export default function SinaContextualCue({ message, state = 'warning', title, className = '' }) {
  const sina = getSinaState(state);
  const defaultTitles = {
    success: '¡Qué buena noticia!',
    error: 'No pudimos grabar la factura',
    warning: 'Revisemos esto antes de seguir',
    info: 'Te cuento lo que está pasando',
  };

  if (!message) return null;

  return (
    <div className={`sina-contextual-cue sina-contextual-cue--${state} ${className}`.trim()} role="status">
      <img className="sina-contextual-cue__image" src={sina.image} alt="Sina te avisa" />
      <div className="sina-contextual-cue__bubble">
        <strong>{title || defaultTitles[state] || sina.label}</strong>
        <span>{message}</span>
      </div>
    </div>
  );
}
